import { currentTenantQuery } from "@common/api/tenants"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { ProfileForm } from "./-components/form/profile-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/general/",
)({
  staticData: {
    breadcrumb: [{ label: "Workspace - General" }],
  },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(currentTenantQuery()),
  component: WorkspaceGeneralPage,
})

function WorkspaceGeneralPage(): React.ReactElement {
  const { data: tenant } = useSuspenseQuery(currentTenantQuery())
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="General" />
      <ProfileForm
        tenant={tenant}
        onSave={() =>
          showToast("Saved", "Workspace settings updated.", "success")
        }
      />
    </PageContent>
  )
}
